"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueContainer = exports.SmallOption = exports.OptionLinked = exports.Option = exports.MenuList = exports.Menu = exports.DropdownIndicator = exports.Control = exports.Container = exports.ClearIndicator = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _checkPink = _interopRequireDefault(require("../../assets/img/check-pink.svg"));

var _constants = require("../../assets/js/constants");

var _clearGrey = _interopRequireDefault(require("../../assets/img/clear-grey.svg"));

var _arrowGrey = _interopRequireDefault(require("../../assets/img/arrow-grey.svg"));

var _excluded = ["children"],
    _excluded2 = ["innerRef", "innerProps"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledMenu = (0, _styledComponents["default"])(_reactSelect.components.Menu).withConfig({
  displayName: "dropdown__StyledMenu",
  componentId: "sc-1uoe2sg-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  margin: 0 !important;\n  left: 0;\n  &>div{\n    border-radius: 5px;\n  }\n  box-shadow: 0 4px 10px rgba(198, 215, 233, 0.6) !important;\n"])));

var Menu = function Menu(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(StyledMenu, _extends({
    "data-test": "select-menu"
  }, rest), children);
};

exports.Menu = Menu;

var MenuListStyled = _styledComponents["default"].div.withConfig({
  displayName: "dropdown__MenuListStyled",
  componentId: "sc-1uoe2sg-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-radius: 0;\n  padding: 0;\n  max-height: ", ";\n  overflow-y: auto;\n  overflow-x: hidden;\n  position: relative;\n  -webkit-overflow-scrolling: touch;\n  box-sizing: border-box;\n  &::-webkit-scrollbar {\n    border-radius: 0 5px 5px 0;\n    width: 14px;\n  }\n  &::-webkit-scrollbar-track{\n    background-color: #F4F6FB;\n    border-radius: 0 5px 5px 0;\n  }\n  &::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    height: 30px;\n    background-color: #C6D7E9;\n    box-shadow: inset 0 0 0 2px #F4F6FB;\n  }\n  div{\n    color: #505050;\n  }\n"])), function (props) {
  if (!props.maxHeight) {
    return '300px';
  }

  return props.maxHeight + 'px';
});

var MenuList = function MenuList(props) {
  var children = props.children,
      innerRef = props.innerRef,
      maxHeight = props.maxHeight;
  return /*#__PURE__*/_react["default"].createElement(MenuListStyled, {
    "data-test": "select-menuList",
    ref: innerRef,
    maxHeight: maxHeight
  }, children);
};

exports.MenuList = MenuList;

var StyledOption = _styledComponents["default"].div.withConfig({
  displayName: "dropdown__StyledOption",
  componentId: "sc-1uoe2sg-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  min-height: 48px;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  background-color: ", ";\n  ", ";\n  color: ", ";\n  padding: 8px 30px 8px 20px;\n  transition: background-color linear .2s;\n  cursor: pointer;\n  text-align: left;\n  &:hover {\n    background: #F4F6FB;\n  }\n"])), _constants.COLORS.white, _constants.FONTS.S, _constants.COLORS.black);

var StyledOptionSmall = _styledComponents["default"].div.withConfig({
  displayName: "dropdown__StyledOptionSmall",
  componentId: "sc-1uoe2sg-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  min-height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: ", ";\n  ", ";\n  color: ", ";\n  padding: 6px 20px 6px 10px;\n  transition: background-color linear .2s;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  @media (max-width: 1000px) {\n    min-height: 28px;\n    padding: 4px 20px 4px 10px;\n  }\n"])), _constants.COLORS.white, _constants.FONTS.XS, _constants.COLORS.black, _constants.COLORS.lightGrey);

var StyledIcon = _styledComponents["default"].img.withConfig({
  displayName: "dropdown__StyledIcon",
  componentId: "sc-1uoe2sg-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 22px;\n  margin-top: 4px;\n  margin-left: 4px;\n"])));

var StyledOptionLinked = _styledComponents["default"].a.withConfig({
  displayName: "dropdown__StyledOptionLinked",
  componentId: "sc-1uoe2sg-5"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  text-decoration: none;\n  width: 100%;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: ", ";\n  ", ";\n  color: ", ";\n  padding: 8px 30px 8px 20px;\n  transition: background-color linear .2s;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), _constants.COLORS.white, _constants.FONTS.S, _constants.COLORS.black, _constants.COLORS.lightGrey);

var OptionLinked = function OptionLinked(props) {
  var children = props.children,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  var path = props.data.path ? props.data.path : './';
  return /*#__PURE__*/_react["default"].createElement(StyledOptionLinked, _extends({
    href: path,
    ref: innerRef,
    isFocused: isFocused,
    isSelected: isSelected,
    isDisabled: isDisabled
  }, innerProps), children, isSelected && /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    src: _checkPink["default"],
    alt: "check"
  }));
};

exports.OptionLinked = OptionLinked;

var Option = function Option(props) {
  var children = props.children,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return /*#__PURE__*/_react["default"].createElement(StyledOption, _extends({
    ref: innerRef,
    isFocused: isFocused,
    isSelected: isSelected,
    isDisabled: isDisabled
  }, innerProps), children, isSelected && /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    src: _checkPink["default"],
    alt: "check"
  }));
};

exports.Option = Option;

var SmallOption = function SmallOption(props) {
  var children = props.children,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return /*#__PURE__*/_react["default"].createElement(StyledOptionSmall, _extends({
    ref: innerRef,
    isFocused: isFocused,
    isSelected: isSelected,
    isDisabled: isDisabled
  }, innerProps), children, isSelected && /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    src: _checkPink["default"],
    alt: "check"
  }));
};

exports.SmallOption = SmallOption;

var ControlDiv = _styledComponents["default"].div.withConfig({
  displayName: "dropdown__ControlDiv",
  componentId: "sc-1uoe2sg-6"
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  min-width: 100px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid ", " !important;\n  box-sizing: border-box;\n  border-radius: 5px;\n  cursor: pointer;\n  ", ";\n  background-color: ", ";\n  &:hover {\n    border-color: ", "  !important;\n  }\n"])), function (props) {
  return props.isFocused ? _constants.COLORS.PINK_BRIGHT : _constants.COLORS.lightGrey;
}, _constants.FONTS.S, _constants.COLORS.white, _constants.COLORS.PINK_BRIGHT);

var Control = function Control(_ref) {
  var innerRef = _ref.innerRef,
      innerProps = _ref.innerProps,
      rest = _objectWithoutProperties(_ref, _excluded2);

  delete rest['cx'];
  return /*#__PURE__*/_react["default"].createElement(ControlDiv, _extends({
    ref: innerRef
  }, innerProps, rest));
};

exports.Control = Control;

var Container = _styledComponents["default"].div.withConfig({
  displayName: "dropdown__Container",
  componentId: "sc-1uoe2sg-7"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: ", ";\n  display: block;\n  ", "\n"])), function (props) {
  return props.width || '100%';
}, function (props) {
  return !props.isSearchable && (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    input {\n      user-select: none;\n    }\n  "])));
});

exports.Container = Container;

var Icon = _styledComponents["default"].span.withConfig({
  displayName: "dropdown__Icon",
  componentId: "sc-1uoe2sg-8"
})(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  background: url(", ") 50% 50% no-repeat;\n  width: ", "px;\n  height: ", "px;\n"])), function (_ref2) {
  var path = _ref2.path;
  return path;
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 0 : _ref3$size;
  return size;
}, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 0 : _ref4$size;
  return size;
});

var Indicator = (0, _styledComponents["default"])(_reactSelect.components.DropdownIndicator).withConfig({
  displayName: "dropdown__Indicator",
  componentId: "sc-1uoe2sg-9"
})(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  width: 17px;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  margin-right: 20px;\n  padding: 0 !important;\n"])));
var Clear = (0, _styledComponents["default"])(_reactSelect.components.ClearIndicator).withConfig({
  displayName: "dropdown__Clear",
  componentId: "sc-1uoe2sg-10"
})(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  width: 17px;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  margin-right: 20px;\n  padding: 0 !important;\n"])));
var Value = (0, _styledComponents["default"])(_reactSelect.components.ValueContainer).withConfig({
  displayName: "dropdown__Value",
  componentId: "sc-1uoe2sg-11"
})(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  padding: 2px 16px !important;\n  div:first-of-type{\n    color:", ";\n  }\n  div:last-of-type{\n    color: #505050;\n  }\n"])), function (props) {
  return props.isDisabled ? '#F0F0F0' : '#969696';
});

var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/_react["default"].createElement(Indicator, props, /*#__PURE__*/_react["default"].createElement(Icon, {
    size: "14",
    path: _arrowGrey["default"]
  }));
};

exports.DropdownIndicator = DropdownIndicator;

var ClearIndicator = function ClearIndicator(props) {
  return /*#__PURE__*/_react["default"].createElement(Clear, props, /*#__PURE__*/_react["default"].createElement(Icon, {
    size: "14",
    path: _clearGrey["default"]
  }));
};

exports.ClearIndicator = ClearIndicator;

var ValueContainer = function ValueContainer(props) {
  return /*#__PURE__*/_react["default"].createElement(Value, props);
};

exports.ValueContainer = ValueContainer;